import { RepeatClockIcon } from '@chakra-ui/icons';
import { Td } from '@chakra-ui/react';
import React from 'react';

import { CmFlex, CmIconButton, CmInput, CmText } from '@/components/uiParts';

interface Props {
  newValue: string;
  defaultValue: string;
  isBlank?: boolean;
  index: number;
  handleInputCode: (index: number, newPosCode: string) => void;
  handleResetCode: (index: number) => void;
}

export const PosTableInputAndButton: React.VFC<Props> = ({
  newValue,
  defaultValue,
  isBlank = false,
  index,
  handleInputCode,
  handleResetCode,
}) => {
  return (
    // @ts-ignore TS2590
    <Td padding="10px">
      <CmInput
        size="sm"
        value={newValue}
        border={isBlank ? '1px solid red' : '1px solid gray'}
        borderColor={isBlank ? 'red' : 'gray'}
        focusBorderColor={isBlank ? 'red' : 'gray'}
        onChange={(e) => {
          handleInputCode(index, e.target.value);
        }}
      />
      <CmFlex justifyContent="space-between" alignItems="center" mt="5px">
        <CmText fontSize="12px">
          {defaultValue !== newValue ? '入力中' : '変更なし'}
        </CmText>
        <CmIconButton
          ml="2"
          icon={<RepeatClockIcon />}
          aria-label="cancel"
          type="button"
          onClick={() => handleResetCode(index)}
        />
      </CmFlex>
    </Td>
  );
};
